// ── CALENDAR PAGE (fp-nofodesk-9) — extracted from App.js ──
import { useState, useEffect } from "react";
import { TOKENS } from "../tokens";
import { FONT_H, FONT_UI, useT } from "../theme";
import { API, apiFetch, apiLoadTable, getToken } from "../utils/api";
import { useWindowWidth } from "../hooks/useWindowWidth";

// ── Feature 3: Calendar View ──────────────────────────────────

const REMINDER_KEY = "nofodesk_reminders";
function loadReminders() { try { return JSON.parse(localStorage.getItem(REMINDER_KEY) || "[]"); } catch { return []; } }
function saveReminders(list) { localStorage.setItem(REMINDER_KEY, JSON.stringify(list)); }
const REPEAT_OPTS = ["Never", "Daily", "Weekly", "Monthly", "Yearly"];

function ReminderModal({ initialDate, onSave, onCancel }) {
  const T = useT();
  const todayStr = new Date().toISOString().slice(0, 10);
  const nowTime  = `${String(new Date().getHours()).padStart(2,"0")}:${String(new Date().getMinutes()).padStart(2,"0")}`;
  const [title,      setTitle]      = useState("");
  const [notes,      setNotes]      = useState("");
  const [url,        setUrl]        = useState("");
  const [date,       setDate]       = useState(initialDate || todayStr);
  const [enableTime, setEnableTime] = useState(true);
  const [time,       setTime]       = useState(nowTime);
  const [urgent,     setUrgent]     = useState(false);
  const [repeat,     setRepeat]     = useState("Never");
  const [endRepeat,  setEndRepeat]  = useState("Never");

  const handleSave = () => {
    if (!title.trim()) { alert("Please add a title."); return; }
    onSave({ id: crypto.randomUUID(), title: title.trim(), notes, url, date, enableTime, time, urgent, repeat, endRepeat, notified: false, createdAt: new Date().toISOString() });
  };

  const inp = (extra = {}) => ({ width: "100%", padding: "11px 14px", background: "transparent", border: "none", color: T.text, fontSize: 14, outline: "none", fontFamily: FONT_UI, boxSizing: "border-box", ...extra });
  const row = (extra = {}) => ({ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "13px 16px", borderBottom: `1px solid ${T.border}`, ...extra });
  const Toggle = ({ on, onToggle }) => (
    <div onClick={onToggle} style={{ width: 44, height: 26, borderRadius: 13, background: on ? "#22c55e" : T.border, cursor: "pointer", position: "relative", transition: "background 0.2s", flexShrink: 0 }}>
      <div style={{ position: "absolute", top: 3, left: on ? 21 : 3, width: 20, height: 20, borderRadius: "50%", background: "#fff", boxShadow: "0 1px 4px rgba(0,0,0,0.35)", transition: "left 0.2s" }} />
    </div>
  );

  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 2000, background: "rgba(0,0,0,0.75)", display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
      <div style={{ background: T.bgCard, borderRadius: 14, width: "100%", maxWidth: 430, maxHeight: "90vh", overflow: "hidden", display: "flex", flexDirection: "column", boxShadow: "0 28px 70px rgba(0,0,0,0.6)" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 18px", borderBottom: `1px solid ${T.border}`, flexShrink: 0 }}>
          <button onClick={onCancel} style={{ background: "none", border: "none", color: T.textMuted, cursor: "pointer", fontSize: 24, lineHeight: 1 }}>×</button>
          <span style={{ fontSize: 16, fontWeight: 600, color: T.text, fontFamily: FONT_UI }}>New Reminder</span>
          <button onClick={handleSave} style={{ background: "none", border: "none", color: TOKENS.gold, cursor: "pointer", fontSize: 15, fontWeight: 700, fontFamily: FONT_UI }}>Save</button>
        </div>
        <div style={{ overflowY: "auto", flex: 1 }}>
          <div style={{ margin: "14px 14px 0", background: T.bgElevated, borderRadius: 12, border: `1px solid ${T.border}`, overflow: "hidden" }}>
            <input value={title} onChange={e => setTitle(e.target.value)} placeholder="Title" style={{ ...inp(), borderBottom: `1px solid ${T.border}` }} />
            <textarea value={notes} onChange={e => setNotes(e.target.value)} placeholder="Notes" rows={2} style={{ ...inp({ resize: "none", display: "block" }), borderBottom: `1px solid ${T.border}` }} />
            <input value={url} onChange={e => setUrl(e.target.value)} placeholder="URL" style={inp()} />
          </div>
          <div style={{ fontSize: 11, color: T.textMuted, fontFamily: FONT_UI, padding: "14px 14px 6px", textTransform: "uppercase", letterSpacing: "0.08em" }}>Date &amp; Time</div>
          <div style={{ margin: "0 14px", background: T.bgElevated, borderRadius: 12, border: `1px solid ${T.border}`, overflow: "hidden" }}>
            <div style={row()}>
              <span style={{ fontSize: 15, color: T.text, fontFamily: FONT_UI }}>Date</span>
              <input type="date" value={date} onChange={e => setDate(e.target.value)} style={{ background: "transparent", border: "none", color: "#ef4444", fontFamily: FONT_UI, fontSize: 14, outline: "none", cursor: "pointer" }} />
            </div>
            <div style={row()}>
              <span style={{ fontSize: 15, color: T.text, fontFamily: FONT_UI }}>Time</span>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                {enableTime && <input type="time" value={time} onChange={e => setTime(e.target.value)} style={{ background: "transparent", border: "none", color: "#ef4444", fontFamily: FONT_UI, fontSize: 14, outline: "none" }} />}
                <Toggle on={enableTime} onToggle={() => setEnableTime(v => !v)} />
              </div>
            </div>
            <div style={{ ...row({ borderBottom: "none" }) }}>
              <div>
                <div style={{ fontSize: 15, color: T.text, fontFamily: FONT_UI }}>Urgent</div>
                <div style={{ fontSize: 11, color: T.textMuted, fontFamily: FONT_UI, marginTop: 2 }}>Mark as urgent to set an alarm.</div>
              </div>
              <Toggle on={urgent} onToggle={() => setUrgent(v => !v)} />
            </div>
          </div>
          <div style={{ margin: "14px 14px 0", background: T.bgElevated, borderRadius: 12, border: `1px solid ${T.border}`, overflow: "hidden" }}>
            <div style={row()}>
              <span style={{ fontSize: 15, color: T.text, fontFamily: FONT_UI }}>Repeat</span>
              <select value={repeat} onChange={e => setRepeat(e.target.value)} style={{ background: "transparent", border: "none", color: T.textMuted, fontFamily: FONT_UI, fontSize: 14, outline: "none", cursor: "pointer" }}>
                {REPEAT_OPTS.map(o => <option key={o} value={o}>{o}</option>)}
              </select>
            </div>
            <div style={{ ...row({ borderBottom: "none" }) }}>
              <span style={{ fontSize: 15, color: T.text, fontFamily: FONT_UI }}>End Repeat</span>
              <select value={endRepeat} onChange={e => setEndRepeat(e.target.value)} style={{ background: "transparent", border: "none", color: T.textMuted, fontFamily: FONT_UI, fontSize: 14, outline: "none", cursor: "pointer" }}>
                {["Never", "On Date"].map(o => <option key={o} value={o}>{o}</option>)}
              </select>
            </div>
          </div>
          <div style={{ margin: "14px", background: T.bgElevated, borderRadius: 12, border: `1px solid ${T.border}`, overflow: "hidden" }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "13px 16px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <div style={{ width: 30, height: 30, borderRadius: "50%", background: "#3b82f6", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 16 }}>≡</div>
                <span style={{ fontSize: 15, color: T.text, fontFamily: FONT_UI }}>List</span>
              </div>
              <span style={{ fontSize: 14, color: T.textMuted, fontFamily: FONT_UI }}>Reminders ›</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function UrgentAlert({ reminder, onDismiss }) {
  return (
    <div style={{ position: "fixed", top: 20, left: "50%", transform: "translateX(-50%)", zIndex: 3000, background: "#ef4444", borderRadius: 12, padding: "16px 20px", boxShadow: "0 8px 32px rgba(239,68,68,0.5)", display: "flex", alignItems: "center", gap: 14, minWidth: 280, maxWidth: 400 }}>
      <span style={{ fontSize: 26 }}>⏰</span>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 15, fontWeight: 700, color: "#fff", fontFamily: FONT_UI }}>{reminder.title}</div>
        {reminder.notes && <div style={{ fontSize: 12, color: "rgba(255,255,255,0.85)", marginTop: 3, fontFamily: FONT_UI }}>{reminder.notes}</div>}
      </div>
      <button onClick={onDismiss} style={{ background: "rgba(255,255,255,0.2)", border: "none", color: "#fff", cursor: "pointer", fontSize: 13, fontWeight: 600, fontFamily: FONT_UI, padding: "6px 12px", borderRadius: 8 }}>Dismiss</button>
    </div>
  );
}

function CalendarView() {
  const T = useT();
  const GARAMOND = FONT_H;
  const isMobile = useWindowWidth() < 768;
  const now = new Date();
  const [year,     setYear]     = useState(now.getFullYear());
  const [month,    setMonth]    = useState(now.getMonth());
  const [selected, setSelected] = useState(null);

  const [applications,  setCalApps]    = useState([]);
  const [activeGrants,  setCalActive]  = useState([]);
  const [trackedGrants, setCalTracked] = useState([]);
  const [capSteps,      setCapSteps]    = useState([]);
  const [subReports,    setSubReports]  = useState([]);
  const [effortDue,     setEffortDue]   = useState([]);
  const [inventories,   setInventories] = useState([]);

  const [reminders,         setReminders]         = useState(loadReminders);
  const [showReminderModal, setShowReminderModal]  = useState(false);
  const [reminderInitDate,  setReminderInitDate]   = useState(null);
  const [urgentAlert,       setUrgentAlert]        = useState(null);

  useEffect(() => {
    if (!getToken()) return;
    Promise.all([
      apiLoadTable('active-grants'),
      apiLoadTable('pipeline-apps'),
      apiLoadTable('tracked-grants'),
    ]).then(([ag, apps, tracked]) => {
      if (ag)      setCalActive(ag);
      if (apps)    setCalApps(apps);
      if (tracked) setCalTracked(tracked);
    });
    apiFetch(`${API}/findings/calendar`).then((r) => (r.ok ? r.json() : null)).then((d) => d && setCapSteps(d.entries || [])).catch(() => {});
    apiFetch(`${API}/subrecipients/calendar`).then((r) => (r.ok ? r.json() : null)).then((d) => d && setSubReports(d.entries || [])).catch(() => {});
    apiFetch(`${API}/effort/calendar`).then((r) => (r.ok ? r.json() : null)).then((d) => d && setEffortDue(d.entries || [])).catch(() => {});
    apiFetch(`${API}/equipment/calendar`).then((r) => (r.ok ? r.json() : null)).then((d) => d && setInventories(d.entries || [])).catch(() => {});
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (typeof Notification !== "undefined" && Notification.permission === "default") {
      Notification.requestPermission();
    }
    const check = () => {
      const n = new Date();
      const todayStr    = n.toISOString().slice(0, 10);
      const currentTime = `${String(n.getHours()).padStart(2,"0")}:${String(n.getMinutes()).padStart(2,"0")}`;
      let changed = false;
      const updated = reminders.map(r => {
        if (r.notified && r.repeat === "Never") return r;
        const isDue = r.enableTime
          ? r.date === todayStr && r.time === currentTime
          : r.date === todayStr && !r.notified;
        if (!isDue) return r;
        if (typeof Notification !== "undefined" && Notification.permission === "granted") {
          try { new Notification(r.title, { body: r.notes || "Grant reminder" }); } catch {}
        }
        if (r.urgent) setUrgentAlert(r);
        changed = true;
        if (r.repeat === "Never") return { ...r, notified: true };
        const nd = new Date(r.date);
        if (r.repeat === "Daily")   nd.setDate(nd.getDate() + 1);
        if (r.repeat === "Weekly")  nd.setDate(nd.getDate() + 7);
        if (r.repeat === "Monthly") nd.setMonth(nd.getMonth() + 1);
        if (r.repeat === "Yearly")  nd.setFullYear(nd.getFullYear() + 1);
        return { ...r, date: nd.toISOString().slice(0, 10) };
      });
      if (changed) { setReminders(updated); saveReminders(updated); }
    };
    check();
    const iv = setInterval(check, 30000);
    return () => clearInterval(iv);
  }, [reminders]);

  const evMap = {};
  const addEv = (dateStr, label, name, color) => {
    if (!dateStr) return;
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return;
    const k = `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
    if (!evMap[k]) evMap[k] = [];
    evMap[k].push({ label, name, color });
  };
  applications.forEach(a => {
    if (a.deadline)      addEv(a.deadline,      "Deadline",  a.title || a.funder, "#f97316");
    if (a.submittedDate) addEv(a.submittedDate,  "Submitted", a.title || a.funder, "#4ade80");
  });
  activeGrants.forEach(g => {
    if (g.end)   addEv(g.end,   "Grant End",   g.shortTitle || g.title, "#ef4444");
    if (g.start) addEv(g.start, "Grant Start", g.shortTitle || g.title, "#22d3ee");
  });
  trackedGrants.forEach(g => {
    if (g.deadline && g.deadline !== "Not specified") addEv(g.deadline, "Tracked", g.title, "#C9A227");
  });
  capSteps.forEach(c => addEv(c.date, c.overdue ? "CAP step overdue" : "CAP step due", c.name, c.overdue ? "#dc2626" : "#a855f7"));
  subReports.forEach(c => addEv(c.date, c.overdue ? "Subrecipient report overdue" : "Subrecipient report due", c.name, c.overdue ? "#dc2626" : "#0891b2"));
  effortDue.forEach(c => addEv(c.date, c.overdue ? "Effort certification overdue" : "Effort certification due", c.name, c.overdue ? "#dc2626" : "#0ea5e9"));
  inventories.forEach(c => addEv(c.date, c.overdue ? "Inventory overdue" : "Inventory due", c.name, c.overdue ? "#dc2626" : "#65a30d"));
  reminders.forEach(r => {
    if (!r.notified || r.repeat !== "Never") addEv(r.date, "Reminder", r.title, "#818cf8");
  });

  const firstDay    = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const monthName   = new Date(year, month, 1).toLocaleDateString("en-US", { month: "long", year: "numeric" });
  const cells       = [...Array(firstDay).fill(null), ...Array.from({ length: daysInMonth }, (_, i) => i + 1)];
  const isToday     = (d) => d === now.getDate() && month === now.getMonth() && year === now.getFullYear();
  const prevMonth   = () => { setSelected(null); if (month === 0) { setMonth(11); setYear(y => y - 1); } else setMonth(m => m - 1); };
  const nextMonth   = () => { setSelected(null); if (month === 11) { setMonth(0); setYear(y => y + 1); } else setMonth(m => m + 1); };

  const openReminderModal = (d) => {
    const ds = d ? `${year}-${String(month + 1).padStart(2,"0")}-${String(d).padStart(2,"0")}` : null;
    setReminderInitDate(ds);
    setShowReminderModal(true);
  };
  const handleSaveReminder = (r) => {
    const updated = [...reminders, r];
    setReminders(updated);
    saveReminders(updated);
    setShowReminderModal(false);
    setReminderInitDate(null);
  };
  const handleDeleteReminder = (id) => {
    const updated = reminders.filter(r => r.id !== id);
    setReminders(updated);
    saveReminders(updated);
  };

  const selectedReminders = selected
    ? reminders.filter(r => { const rd = new Date(r.date); return rd.getFullYear() === year && rd.getMonth() === month && rd.getDate() === selected.d; })
    : [];
  const selectedGrantEvs = selected ? (selected.evs || []).filter(e => e.label !== "Reminder") : [];

  return (
    <div style={{ padding: isMobile ? "14px 10px" : "24px", maxWidth: 980, margin: "0 auto" }}>
      {urgentAlert && <UrgentAlert reminder={urgentAlert} onDismiss={() => setUrgentAlert(null)} />}
      {showReminderModal && (
        <ReminderModal initialDate={reminderInitDate} onSave={handleSaveReminder} onCancel={() => { setShowReminderModal(false); setReminderInitDate(null); }} />
      )}

      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16, flexWrap: "wrap", gap: 10 }}>
        <h2 style={{ margin: 0, fontFamily: GARAMOND, fontSize: 22, fontWeight: 400, color: T.text }}>📅 Grant Calendar</h2>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <button onClick={prevMonth} style={{ padding: "5px 13px", background: T.bgElevated, border: `1px solid ${T.border}`, color: T.text, borderRadius: 6, cursor: "pointer", fontSize: 16, lineHeight: 1 }}>‹</button>
          <span style={{ fontSize: 14, fontFamily: GARAMOND, color: T.text, minWidth: 155, textAlign: "center" }}>{monthName}</span>
          <button onClick={nextMonth} style={{ padding: "5px 13px", background: T.bgElevated, border: `1px solid ${T.border}`, color: T.text, borderRadius: 6, cursor: "pointer", fontSize: 16, lineHeight: 1 }}>›</button>
          <button onClick={() => openReminderModal(null)} style={{ padding: "6px 14px", background: TOKENS.gold, border: "none", color: "#0A1628", borderRadius: 6, cursor: "pointer", fontSize: 13, fontWeight: 600, fontFamily: FONT_UI, marginLeft: 4 }}>
            + Reminder
          </button>
        </div>
      </div>

      {/* Legend */}
      <div style={{ display: "flex", gap: 14, marginBottom: 12, flexWrap: "wrap" }}>
        {[["Deadline","#f97316"],["Submitted","#4ade80"],["Grant End","#ef4444"],["Grant Start","#22d3ee"],["Tracked","#C9A227"],["Reminder","#818cf8"]].map(([lbl, col]) => (
          <div key={lbl} style={{ display: "flex", alignItems: "center", gap: 5, fontSize: 11, color: T.textMuted, fontFamily: FONT_UI }}>
            <span style={{ width: 8, height: 8, borderRadius: "50%", background: col, flexShrink: 0 }} />{lbl}
          </div>
        ))}
      </div>

      {/* Day headers */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 3, marginBottom: 3 }}>
        {["Sun","Mon","Tue","Wed","Thu","Fri","Sat"].map(d => (
          <div key={d} style={{ textAlign: "center", fontSize: 11, fontWeight: 600, color: T.textMuted, fontFamily: FONT_UI, padding: "5px 0", background: T.bgElevated, borderRadius: 4 }}>{d}</div>
        ))}
      </div>

      {/* Grid */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 3 }}>
        {cells.map((d, i) => {
          if (!d) return <div key={i} style={{ minHeight: isMobile ? 56 : 80 }} />;
          const k   = `${year}-${month}-${d}`;
          const evs = evMap[k] || [];
          const tod = isToday(d);
          const sel = selected?.d === d;
          const maxPills = isMobile ? 1 : 2;
          return (
            <div key={i} onClick={() => setSelected(sel ? null : { d, evs })}
              style={{ minHeight: isMobile ? 56 : 80, padding: "5px 6px", background: sel ? T.bgElevated : (tod ? "rgba(201,162,39,0.08)" : T.bgSurface), border: `1px solid ${sel ? TOKENS.gold : (tod ? TOKENS.gold : T.border)}`, borderRadius: 6, cursor: "pointer", transition: "border-color 0.1s, background 0.1s" }}>
              <div style={{ fontSize: isMobile ? 11 : 12, fontWeight: tod ? 700 : 500, color: tod ? TOKENS.gold : T.text, marginBottom: 3, lineHeight: 1 }}>{d}</div>
              {evs.slice(0, maxPills).map((ev, j) => (
                <div key={j} style={{ fontSize: isMobile ? 8 : 10, padding: "2px 4px", borderRadius: 3, background: ev.color + "30", color: ev.color, fontFamily: FONT_UI, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", marginBottom: 2, lineHeight: 1.3 }}>
                  {ev.label === "Reminder" ? "🔔 " : ""}{ev.name ? ev.name.slice(0, isMobile ? 8 : 13) : ev.label}
                </div>
              ))}
              {evs.length > maxPills && <div style={{ fontSize: 9, color: T.textFaint, fontFamily: FONT_UI }}>+{evs.length - maxPills}</div>}
            </div>
          );
        })}
      </div>

      {/* Day panel */}
      {selected && (
        <div style={{ marginTop: 14, padding: "16px 18px", background: T.bgElevated, border: `1px solid ${T.border}`, borderRadius: 10 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
            <div style={{ fontSize: 14, fontWeight: 600, color: T.text, fontFamily: GARAMOND }}>
              {new Date(year, month, selected.d).toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric", year: "numeric" })}
            </div>
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
              <button onClick={() => openReminderModal(selected.d)} style={{ padding: "5px 12px", background: TOKENS.gold, border: "none", color: "#0A1628", fontSize: 12, fontWeight: 600, borderRadius: 6, cursor: "pointer", fontFamily: FONT_UI }}>+ Reminder</button>
              <button onClick={() => setSelected(null)} style={{ background: "transparent", border: "none", color: T.textFaint, cursor: "pointer", fontSize: 20, lineHeight: 1 }}>×</button>
            </div>
          </div>

          {selectedGrantEvs.length > 0 && (
            <div style={{ marginBottom: selectedReminders.length > 0 ? 14 : 0 }}>
              <div style={{ fontSize: 10, color: T.textMuted, fontFamily: FONT_UI, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 8 }}>Grant Events</div>
              {selectedGrantEvs.map((ev, i) => (
                <div key={i} style={{ display: "flex", gap: 10, padding: "8px 0", borderTop: i > 0 ? `1px solid ${T.border}` : "none", alignItems: "flex-start" }}>
                  <span style={{ width: 8, height: 8, borderRadius: "50%", background: ev.color, flexShrink: 0, marginTop: 4 }} />
                  <div>
                    <div style={{ fontSize: 11, color: ev.color, fontFamily: FONT_UI, fontWeight: 600 }}>{ev.label}</div>
                    <div style={{ fontSize: 13, color: T.text, fontFamily: GARAMOND, marginTop: 2 }}>{ev.name}</div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {selectedReminders.length > 0 && (
            <div>
              {selectedGrantEvs.length > 0 && <div style={{ height: 1, background: T.border, marginBottom: 12 }} />}
              <div style={{ fontSize: 10, color: T.textMuted, fontFamily: FONT_UI, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 8 }}>Reminders</div>
              {selectedReminders.map(r => (
                <div key={r.id} style={{ display: "flex", gap: 10, padding: "8px 0", borderTop: `1px solid ${T.border}`, alignItems: "flex-start" }}>
                  <span style={{ fontSize: 18, lineHeight: 1 }}>{r.urgent ? "⏰" : "🔔"}</span>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 13, color: T.text, fontFamily: FONT_UI, fontWeight: 600 }}>{r.title}</div>
                    {r.notes && <div style={{ fontSize: 11, color: T.textMuted, fontFamily: FONT_UI, marginTop: 2 }}>{r.notes}</div>}
                    <div style={{ fontSize: 11, color: "#818cf8", fontFamily: FONT_UI, marginTop: 2 }}>
                      {r.enableTime && r.time ? r.time : "All day"}{r.repeat !== "Never" ? ` · Repeats ${r.repeat}` : ""}
                    </div>
                    {r.urgent && <div style={{ fontSize: 10, color: "#ef4444", fontFamily: FONT_UI, marginTop: 2, fontWeight: 700 }}>URGENT</div>}
                  </div>
                  <button onClick={() => handleDeleteReminder(r.id)} style={{ background: "none", border: "none", color: T.textFaint, cursor: "pointer", fontSize: 18, lineHeight: 1, padding: "2px 4px" }}>×</button>
                </div>
              ))}
            </div>
          )}

          {selectedGrantEvs.length === 0 && selectedReminders.length === 0 && (
            <div style={{ fontSize: 13, color: T.textMuted, fontFamily: FONT_UI, textAlign: "center", padding: "10px 0" }}>No events. Tap "+ Reminder" to add one for this day.</div>
          )}
        </div>
      )}
    </div>
  );
}

export default CalendarView;
